var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"myChart",attrs:{"id":"myChart","width":"400","height":"200"}})])}
var staticRenderFns = []

export { render, staticRenderFns }